import {ImageHelper} from "../../../../../../../modules/common/image/imageHelper";
import {Base64Utils} from "../../../../../../../modules/core/utils/base64.utils";
import {FormValueReadableValue} from "../../../type-handler/abstract-field-input-type-handler.component";

export class DrawableImageV2FieldInputTypeHandlerComponentUtils {
    public static resolveReadableValues(value: any): Promise<FormValueReadableValue[]> {
        return new Promise<FormValueReadableValue[]>(resolve => {
            if (!value) {
                resolve([]);
            }
            try {
                const json = JSON.parse(value);
                if (json.image && !json.backgroundImage) {
                    resolve([
                        FormValueReadableValue.ofImage(json.image)
                       ]);
                } else if(!json.image && json.backgroundImage){
                    resolve([FormValueReadableValue.ofImage(json.backgroundImage)]);
                } else {
                    ImageHelper.combineImagesFromBase64(json.backgroundImage, json.image).then(blob => {
                        console.log(blob);
                        Base64Utils.blobToBase64(blob)
                            .then(base64 => {
                                resolve([FormValueReadableValue.ofImage(base64)]);
                            })
                            .catch(() => resolve([
                                FormValueReadableValue.ofText('Une erreur est survenue')]))
                    }).catch(error =>  resolve([
                        FormValueReadableValue.ofText('Une erreur est survenue')]));
                }
            } catch(error) {
                resolve([
                    FormValueReadableValue.ofText('Une erreur est survenue')]);
            }
        })
    }
}